module.exports = __webpack_public_path__ + "c352e7b670254267d30d47bc3a52b3b2.otf";